/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Color_PurpleInputs */



/**
* | output |
* | --- |
* | "Purple" |
*
* @param {Settings_Template_Color_PurpleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_color_purple = /** @type {((inputs?: Settings_Template_Color_PurpleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Color_PurpleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Paars")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Violet")
	return /** @type {LocalizedString} */ ("Purple")
});